import React from 'react';
import {
  UserOutlined,
  LockOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  ShoppingCartOutlined,
  DatabaseOutlined,
  HomeOutlined,
  DashboardOutlined,
  SettingOutlined,
  FileOutlined,
  TeamOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  SearchOutlined,
  EditOutlined,
  CopyOutlined,
  DeleteOutlined,
  DownloadOutlined,
  UploadOutlined,
  SaveOutlined,
  FilterOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  MailOutlined,
  PhoneOutlined,
  LinkedinOutlined,
  ArrowLeftOutlined,
  BellOutlined,
  SecurityScanOutlined,
  GlobalOutlined,
  CloseOutlined,
  CloseCircleOutlined,
  WifiOutlined,
  ArrowRightOutlined,
  LoadingOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
  ReloadOutlined,
  InfoCircleOutlined,
  TruckOutlined,
  InboxOutlined,
  HolderOutlined,
  UpOutlined,
  DownOutlined,
  ToolOutlined,
  SlidersOutlined,
  ContainerOutlined,
  LoginOutlined,
  BorderOutlined,
  MessageOutlined,
  CalendarOutlined,
  BulbOutlined,
  ExportOutlined,
  UnorderedListOutlined,
  CodeOutlined,
  TagOutlined,
} from '@ant-design/icons';

interface IconProps {
  className?: string;
  style?: React.CSSProperties;
  [key: string]: any;
}

// Login/Auth icons
export const IconUser = (props: IconProps) => <UserOutlined {...props} />;
export const IconLock = (props: IconProps) => <LockOutlined {...props} />;
export const IconEye = (props: IconProps) => <EyeInvisibleOutlined {...props} />;
export const IconEyeOpen = (props: IconProps) => <EyeOutlined {...props} />;

// Navigation icons
export const IconHome = (props: IconProps) => <HomeOutlined {...props} />;
export const IconDashboard = (props: IconProps) => <DashboardOutlined {...props} />;
export const IconSettings = (props: IconProps) => <SettingOutlined {...props} />;
export const IconFile = (props: IconProps) => <FileOutlined {...props} />;
export const IconTeam = (props: IconProps) => <TeamOutlined {...props} />;
export const IconMenuFold = (props: IconProps) => <MenuFoldOutlined {...props} />;
export const IconMenuUnfold = (props: IconProps) => <MenuUnfoldOutlined {...props} />;
export const IconLogout = (props: IconProps) => <LogoutOutlined {...props} />;

// Action icons
export const IconSearch = (props: IconProps) => <SearchOutlined {...props} />;
export const IconEdit = (props: IconProps) => <EditOutlined {...props} />;
export const IconDuplicate = (props: IconProps) => <CopyOutlined {...props} />;
export const IconDelete = (props: IconProps) => <DeleteOutlined {...props} />;
export const IconDownload = (props: IconProps) => <DownloadOutlined {...props} />;
export const IconUpload = (props: IconProps) => <UploadOutlined {...props} />;
export const IconSave = (props: IconProps) => <SaveOutlined {...props} />;
export const IconFilterOutlined = (props: IconProps) => <FilterOutlined {...props} />;

// Status icons
export const IconCheckCircle = (props: IconProps) => <CheckCircleOutlined {...props} />;
export const IconClockCircle = (props: IconProps) => <ClockCircleOutlined {...props} />;

// Communication icons
export const IconMail = (props: IconProps) => <MailOutlined {...props} />;
export const IconPhone = (props: IconProps) => <PhoneOutlined {...props} />;
export const IconLinkedin = (props: IconProps) => <LinkedinOutlined {...props} />;

// Navigation icons
export const IconArrowLeft = (props: IconProps) => <ArrowLeftOutlined {...props} />;
export const IconNext = (props: IconProps) => <ArrowRightOutlined {...props} />;

// Notification icons
export const IconBell = (props: IconProps) => <BellOutlined {...props} />;
export const IconSecurityScan = (props: IconProps) => <SecurityScanOutlined {...props} />;
export const IconGlobal = (props: IconProps) => <GlobalOutlined {...props} />;
export const IconClose = (props: IconProps) => <CloseOutlined {...props} />;
export const IconCloseCircle = (props: IconProps) => <CloseCircleOutlined {...props} />;
export const IconWifi = (props: IconProps) => <WifiOutlined {...props} />;

// Shopping icons
export const IconShoppingCart = (props: IconProps) => <ShoppingCartOutlined {...props} />;

export const IconDatabase = (props: IconProps) => <DatabaseOutlined {...props} />;

export const IconLoading = (props: IconProps) => <LoadingOutlined {...props} />;

export const IconCheck = (props: IconProps) => <CheckOutlined {...props} />;

export const IconRadialSelected = (props: IconProps) => <CheckCircleOutlined {...props} />;

export const IconWarehouse = (props: IconProps) => <ContainerOutlined {...props} />;
export const IconDoorOpen = (props: IconProps) => <LoginOutlined {...props} />;
export const IconClock = (props: IconProps) => <ClockCircleOutlined {...props} />;
export const IconWrench = (props: IconProps) => <ToolOutlined {...props} />;
export const IconCheckBoxOutlineBlank = (props: IconProps) => <BorderOutlined {...props} />;
export const IconCheckFa = (props: IconProps) => <CheckOutlined {...props} />;
export const IconShoppingCartFa = (props: IconProps) => <ShoppingCartOutlined {...props} />;
export const IconEyeOutlined = (props: IconProps) => <EyeOutlined {...props} />;
export const IconDownloadFa = (props: IconProps) => <DownloadOutlined {...props} />;
export const IconExclamationCircle = (props: IconProps) => <ExclamationCircleOutlined {...props} />;
export const IconInfoCircle = (props: IconProps) => <InfoCircleOutlined {...props} />;
export const IconFeedback = (props: IconProps) => <MessageOutlined {...props} />;
export const IconEvent = (props: IconProps) => <CalendarOutlined {...props} />;
export const IconLightbulb = (props: IconProps) => <BulbOutlined {...props} />;
export const IconFileFa = (props: IconProps) => <FileOutlined {...props} />;
export const IconExternalLink = (props: IconProps) => <ExportOutlined {...props} />;
export const IconCode = (props: IconProps) => <CodeOutlined {...props} />;
export const IconLabel = (props: IconProps) => <TagOutlined {...props} />;
export const IconManifest = (props: IconProps) => <UnorderedListOutlined {...props} />;
export const IconRefresh = (props: IconProps) => <ReloadOutlined {...props} />;

export const IconTruck = (props: IconProps) => <TruckOutlined {...props} />;
export const IconInbox = (props: IconProps) => <InboxOutlined {...props} />;
export const IconHolder = (props: IconProps) => <HolderOutlined {...props} />;
export const IconUp = (props: IconProps) => <UpOutlined {...props} />;
export const IconDown = (props: IconProps) => <DownOutlined {...props} />;
export const IconTool = (props: IconProps) => <ToolOutlined {...props} />;
export const IconSliders = (props: IconProps) => <SlidersOutlined {...props} />;

export const IconCheckCircleFa = (props: IconProps) => <CheckCircleOutlined {...props} />;
export const IconLightbulbReg = (props: IconProps) => <BulbOutlined {...props} />;
export const IconCloseMd = (props: IconProps) => <CloseOutlined {...props} />;
